import * as yup from "yup";

export const formSchema = yup.object().shape({
  startTph: yup.number().required("Awal tph wajib diisikan"),
  endTph: yup.number().required("Akhir tph wajib diisikan"),
});
